import {inject, Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ListData} from '@aviary/store/common/common.types';
import {buildQueryParamsFrom} from '@aviary/store/common/list-data.helpers';
import {CreateItemRequestValue, ItemRequest, ItemRequestStatus} from '@store/item-requests/item-requests.types';
import {Params} from '@angular/router';
import {ApiService} from '@aviary/services/api.service';
import {
  contextWithErrorHandlerForCancelItemRequest,
  contextWithErrorHandlerForCreateItemRequest,
  contextWithErrorHandlerForLoadItemRequestDetails,
  contextWithErrorHandlerForMarkItemRequestMessagesAsRead,
  contextWithErrorHandlerForSendItemRequestMessage,
} from '@store/item-requests/item-requests.handlers';

@Injectable({providedIn: 'root'})
export class ItemRequestsService {

  private readonly apiService: ApiService = inject(ApiService);

  public loadItemRequestDetails(itemRequestId: number): Observable<ItemRequest> {
    const endpoint: string = `patrons/v1/requests/${itemRequestId}`;

    return this.apiService.getSingleObject(endpoint, {context: contextWithErrorHandlerForLoadItemRequestDetails()});
  }

  public loadItemRequests(queryParams: Params, statuses: ItemRequestStatus[]): Observable<ListData<ItemRequest>> {
    const endpoint: string = 'patrons/v1/requests';
    const params: HttpParams = buildQueryParamsFrom({...queryParams, statuses, sort: 'created,desc'});

    return this.apiService.getListData(endpoint, {params});
  }

  public createItemRequest(value: CreateItemRequestValue): Observable<ItemRequest> {
    const endpoint: string = 'patrons/v2/patrons/requests';

    return this.apiService.postAndReturnSingleObject(endpoint, value, {context: contextWithErrorHandlerForCreateItemRequest()});
  }

  public sendItemRequestMessage(itemRequestId: number, message: string): Observable<void> {
    const endpoint: string = `patrons/v5/requests/${itemRequestId}/comments`;
    return this.apiService.post(endpoint, message, {context: contextWithErrorHandlerForSendItemRequestMessage()});
  }

  public markItemRequestMessagesAsRead(itemRequestId: number): Observable<void> {
    const endpoint: string = `patrons/v5/requests/${itemRequestId}/comments/read`;
    return this.apiService.patchWithoutBody(endpoint, {context: contextWithErrorHandlerForMarkItemRequestMessagesAsRead()});
  }

  public cancelItemRequest(itemRequestId: number): Observable<void> {
    const endpoint: string = `patrons/v5/requests/${itemRequestId}/cancel`;
    return this.apiService.patchWithoutBody(endpoint, {context: contextWithErrorHandlerForCancelItemRequest()});
  }
}
